var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    staticClass: "evaluation-form-scoped",
    attrs: {
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评价意见",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1)], 1), _vm._v(" "), (_vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    ref: "content",
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "text-content",
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), _c('society-form-tips', {
    attrs: {
      "isSociety": this.recruitType !== 'campus'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b317922"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-normal.vue
// module id = null
// module chunks = 